import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { UserProvider } from '../hooks/useUser';
import { commonRoutes } from '../commonPages/CommonRoutes';
import Layout from './components/Layout';
import Homepage from './pages/Homepage';
import SettingsPage from './pages/SettingsPage';
import DomainSearchPage from './pages/DomainSearchPage';
import { RheaThemeProvider } from './theme/RheaThemeProvider';
import AgenticSearchPage from './pages/AgenticSearchPage';
import { Helmet } from 'react-helmet';

const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};

const RheaIndex = () => {
  return (
    <UserProvider mountingScreen={<></>}>
      <Helmet>
          <meta name="description" content="Rhea: AI Product Development, Agentic Search, Domain Search" />
          <meta name="keywords" content="Rhea, AI, Product Development, Search, Agentic Search" />
          <title>Rhea</title>
          <link rel="icon" href="/assets/rhea/logo.png" />
      </Helmet>
      <RheaThemeProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/easter-egg" element={<Homepage />} />
              <Route path="/" element={<ExternalRedirect to="https://thoughtful-oasis.com" />} />
              <Route path="/domain" element={<DomainSearchPage />} />
              <Route path="/agentic" element={<AgenticSearchPage />} />
              {commonRoutes}
              {/* Fallback route */}
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/nl" element={<Navigate to="/agentic?agent=rhea_domain" replace />} />
              <Route path="*" element={<ExternalRedirect to="https://thoughtful-oasis.com" />} />
            </Routes>
          </Layout>
        </Router>
      </RheaThemeProvider>
    </UserProvider>
  );
};

export default RheaIndex;